import clsx from 'clsx';
import { forwardRef } from 'react';

import StyleButtonComponent, { getButtonClassName } from 'components/digifi-wrappers/Button/StyleButtonComponent';
import ButtonWithLoadingState , { ButtonWithLoadingStateProps } from 'product_modules/components/ButtonWithLoadingState';

const ButtonWithLoadingStateStyled = StyleButtonComponent(ButtonWithLoadingState, 'root');

const ButtonWithLoadingStateWrapper = forwardRef<HTMLButtonElement, ButtonWithLoadingStateProps>(({ className, ...props }, ref) => {
  return (
    <ButtonWithLoadingStateStyled
      {...props}
      ref={ref}
      className={clsx(getButtonClassName(props.kind), className)}
    />
  );
});

export default ButtonWithLoadingStateWrapper;
